import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-maverick',
  templateUrl: './maverick.component.html',
  styleUrls: ['./maverick.component.scss']
})
export class MaverickComponent {
  constructor(private dialogRef: MatDialogRef<MaverickComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
